import { getRulesApi } from '@services/api/configuration';
import { Rule } from '@services/types';
import {
  DeleteAllRulesRequest,
  ReadEmptyUpgradeRulesRequest,
  ReadUnusedUpgradeRulesRequest,
  ReadUpgradeRulesRequest,
} from '@openapi';

const rules = {
  getRules: (requestParameters?: ReadUpgradeRulesRequest) => {
    return getRulesApi().readUpgradeRules(requestParameters);
  },
  updateRule: (rule: Rule) => {
    return getRulesApi().updateUpgradeRule({ id: rule.id, upgradeRuleRequest: rule });
  },
  getWarningRule: (id: Rule['id']) => {
    return getRulesApi().readValidateInfoForUpdateRule({ id });
  },
  createUpgradeRule: (rule: Rule) => {
    return getRulesApi().createUpgradeRule({ upgradeRuleRequest: rule });
  },
  getRule: (id: Rule['id']) => {
    return getRulesApi().readUpgradeRule({ id });
  },
  deleteRule: (id: Rule['id']) => {
    return getRulesApi().deleteUpgradeRule({ id });
  },
  getUnusedRules: (requestParameters?: ReadUnusedUpgradeRulesRequest) => {
    return getRulesApi().readUnusedUpgradeRules(requestParameters);
  },
  getEmptyRules: (requestParameters?: ReadEmptyUpgradeRulesRequest) => {
    return getRulesApi().readEmptyUpgradeRules(requestParameters);
  },
  deleteRuleList: (requestParameters: DeleteAllRulesRequest) => {
    return getRulesApi().deleteUpgradeRules({ deleteAllRulesRequest: requestParameters });
  },
};

export default rules;
